import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import useNav from '../../hooks/useNav'
import CalendarHomepage from './(page)'
import MonthPage from './month/page'
import { useLingui } from '@lingui/react/macro'

const Calendar = () => {
  const { t } = useLingui()
  const { nav, setNav } = useNav()

  useEffect(()=>{
      setNav({...nav, title:t`Kalender`})
  }, [])

  return (
    <Routes>
        <Route path="" element={<CalendarHomepage />} />
        <Route path="month" element={<MonthPage />} />
    </Routes>
  )
}

export default Calendar